import { AfterViewInit, Directive, ElementRef, inject } from "@angular/core";

@Directive({
    standalone: true,
    selector: "[s25-ng-auto-focus]",
})
export class AutofocusDirective implements AfterViewInit {
    readonly elementRef = inject(ElementRef);
    ngAfterViewInit() {
        this.elementRef.nativeElement.focus();
    }
}
